import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const ControlSecurity = () => {
  const names = ['Module Rights', 'User Rights', 'Audit Trail', 'Coupon Authority', 'Generate Coupon'];

  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container sx={{
        width: "100%",
        maxWidth: "100%"
      }}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Module Rights") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/module-rights-table' }}
                permissions={permissions}
                title="Module Rights"
              />)}

            {hasModulePermission("User Rights") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                // link="#"
                link={{ pathname: '/userpermission' }}
                permissions={permissions}
                title="User Rights"
              />)}

            {/* {hasModulePermission("Audit Trail") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/audit-report' }}
                permissions={permissions}
                title="Audit Trail"
              />)} */}

            {hasModulePermission("Email Configuration") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                // link="/emailconfig-table" 
                link={{ pathname: '/emailconfig-table' }}
                permissions={permissions}
                title="Email Configuration"
              />
            )}

            {hasModulePermission("Payment Gateway Configuration") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                // link="/paymentGatewayConfigTable"
                link={{ pathname: '/paymentGatewayConfigTable' }}
                permissions={permissions}
                title="Payment Gateway Configuration"
              />
            )}

            {hasModulePermission("Send Email") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                // link="/send-email"
                link={{ pathname: '/send-email' }}
                permissions={permissions}
                title="Send Email"
              />
            )}

            {hasModulePermission("Send Email") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/system-parameter' }}
                permissions={permissions}
                title="System Parameter"
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ControlSecurity;